import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every route change.
 * Honours back/forward navigation: if the browser is restoring scroll for a
 * POP event (back/forward), we leave it alone so the user lands where they
 * were. Hash links (#section) also bypass the reset.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Tell the browser we manage scroll restoration ourselves.
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    useEffect(() => {
        // If the URL has a hash, let the browser anchor-scroll do its job.
        if (hash) return;
        // Use instant (no smooth) so the user never sees a flicker scroll.
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        // Some browsers don't support behavior:'instant' yet — belt & braces:
        if (window.scrollY !== 0) window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
}
